module.exports = __webpack_public_path__ + "static/media/hand-with-couch.db21deb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/hand-with-couch.png
// module id = 1177
// module chunks = 27